import { defaultApiState } from '../api.state';

export const latestVideoState = {
  apiState: {
    getLatestVideos: defaultApiState,
    getLatestVideo: defaultApiState,
    deleteLatestVideo: defaultApiState,
    addLatestVideo: defaultApiState,
    updateLatestVideo: defaultApiState,
  },
  latestVideos: [],
  latestVideo: undefined,
};
